export default __webpack_public_path__ + "static/3d-flame-288-5d8bd704aa4c0b0d492a6647327214ad.png";